const DropDown = {

  /**
   * @return {void}
   */
  initialize: function () {
    this.setup();
  },

  /**
   * Set dropdown radio buttons to activate side link
   * @return {void}
   */
  setup: () => {

    let dropdowns = document.querySelectorAll('.dropdown-toggle');
    if (dropdowns.length == 0) {
      return;
    }

    dropdowns.forEach((dropdown) => {

      //Necessary to avoid jquery incompatibilities with bootstrap data-bs-toggle on checkout
      dropdown.addEventListener('click', function (e) {
        let element = e.target.nextElementSibling.firstElementChild;
        if (!element) {
          return;
        }
        if (element.style.display == 'block') {
          element.style.display = 'none';
        } else {
          element.style.display = 'block';
        }

        let inputs = element.parentElement.querySelectorAll('input');
        if (inputs.length == 0) {
          return;
        }

        inputs.forEach((input) => {

          input.addEventListener('click', function (e) {
            let link = input.nextElementSibling;
            if (link) {
              link.click();
            }
          });
        });
      });
    });
  },
};

export default DropDown;